import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
Vue.config.productionTip = false;
import Web3Plugin from './plugins/web3'

Vue.use(Web3Plugin)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
